import { onMounted, onBeforeUnmount } from 'vue'
import { useRoute } from "vue-router";
const useNavListen = () =>{
    const route = useRoute()
    let e = null
    let s = null
    let lastScrollTop = null
    let tab = null
    const t = () => {
        let l = window.scrollY;
        let currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
        if (l > s + 40) {
            if (currentScrollTop < lastScrollTop) {
                // 职位列表也不显示搜索职位按钮
                if (route.fullPath !== '/searchJob') {
                    // 向上滚动
                    e.classList.add("scrolling-up")
                }
            } else {
                // 向下滚动
                e.classList.add("scrolled-past")
                if (l > s + 100 + 40) {
                    e.classList.add("short")
                }
                e.classList.remove("scrolling-up")
                e.classList.remove("open")
            }
           
        } else {
            e.classList.remove("scrolled-past")
            e.classList.remove("short")
            e.classList.remove("scrolling-up")
            e.classList.remove("open")
           
        }
        if (l > 600 && tab){
            tab.classList.add('tab-show')
        } else if (tab) {
            tab.classList.remove("tab-show")
        }
        lastScrollTop = currentScrollTop;
    };
    onMounted(()=>{
        e = document.querySelector(".hc-nav")
        tab = document.querySelector(".move-tab-list")
        if(e){
            s = e.getBoundingClientRect().height
            lastScrollTop = window.pageYOffset || document.documentElement.scrollTop;
            setTimeout(() => {
                window.addEventListener("scroll", t);
            }, 100)
        }
    })
    onBeforeUnmount(()=>{
        window.removeEventListener('scroll',t)
    })
}
export default useNavListen

